import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PagedSelectComponent } from '@components/paged-select/paged-select.component';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AbilityModule } from 'ability';
import { I18NextModule } from 'angular-i18next';
import { MbsUiKitModule } from 'mbs-ui-kit';
import { CompanySelectComponent } from './company-select.component';
import { ComputerSelectComponent } from './computer-select.component';
import { RmmComputerSelectComponent } from './rmm-computer-select.component';

const declarations = [PagedSelectComponent, CompanySelectComponent, ComputerSelectComponent, RmmComputerSelectComponent];

@NgModule({
  declarations: declarations,
  exports: declarations,
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MbsUiKitModule,
    AbilityModule,
    NgbDropdownModule,
    NgbTooltipModule
  ]
})
export class PagedSelectModule {}
